<template>
	<NuxtLink
		:to="href"
		class="group w-full h-full flex flex-col min-h-[168px] overflow-hidden rounded-big border border-dj-gray-light bg-white p-5 transition-all duration-200 hover:-translate-y-0.5 hover:border-dj-blue hover:shadow-[0_16px_40px_rgba(18,36,76,0.08)]"
	>
		<div class="min-w-0 text-left">
			<DjClampedTitle
				:title="name"
				:clamp="2"
				font-class="text-dj-black group-hover:text-dj-blue transition-colors"
			/>
		</div>

		<div class="flex items-center gap-3 mt-2 text-left">
			<p class="text-sm font-medium text-dj-blue whitespace-nowrap">
				{{ $t("locationJobs.openJobs", { count: jobsCount }) }}
			</p>
		</div>

		<div class="mt-3 flex items-end justify-between gap-3">
			<div v-if="categoriesToShow.length" class="flex flex-wrap justify-start gap-2 text-left">
				<span
					v-for="category in categoriesToShow"
					:key="category"
					class="max-w-full rounded-full border border-dj-gray-light bg-dj-gray-minimal/60 px-3 py-1 text-[11px] font-medium text-dj-gray-dark line-clamp-1"
				>
					{{ category }}
				</span>
			</div>

			<span
				aria-hidden="true"
				class="flex justify-center items-center w-dj-50 min-w-dj-50 min-h-dj-50 rounded-full border border-dj-gray-light bg-white text-dj-gray shrink-0 transition-colors group-hover:border-dj-blue group-hover:bg-dj-blue group-hover:text-white"
			>
				<span class="material-icons-outlined text-base">arrow_forward</span>
			</span>
		</div>
	</NuxtLink>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DjClampedTitle from "~/ui-kit/components/card/partials/DjClampedTitle.vue";

const props = withDefaults(
	defineProps<{
		href: string;
		name: string;
		jobsCount: number;
		categories?: string[];
		maxCategories?: number;
	}>(),
	{
		categories: () => [],
		maxCategories: 4,
	}
);

const categoriesToShow = computed(() => props.categories.slice(0, props.maxCategories));
</script>
